module.exports = __webpack_public_path__ + "static/media/pas0_img.310cbe90.JPG";